import type { FC } from 'react';

import type { CompaniesIndustry } from '@xing-com/crate-common-graphql-types';
import { useLoginState } from '@xing-com/crate-hooks-use-login-state';

import { useAllIndustries } from '../../hooks/use-companies-industries';
import { createCompaniesIndustries } from '../../models/industry';
import { ROUTES } from '../../routes';
import { IndustryCard } from '../industry-card/industry-card';
import { SectionContainer } from '../section-container/section-container';
import * as Styled from './section-companies-by-industry.styles';

const LIMIT = 6;

export const SectionCompaniesByIndustries: FC = () => {
  const { isLoggedIn } = useLoginState();
  const { orderedIndustries, loading } = useAllIndustries();

  const subsetIndustries = isLoggedIn
    ? orderedIndustries
    : orderedIndustries.slice(0, LIMIT);

  const collection = (subsetIndustries ?? []) as CompaniesIndustry[];
  const industriesCollection = createCompaniesIndustries(collection);

  return (
    <SectionContainer
      title="CP_INDUSTRIES_SECTION_TITLE"
      subtitle="CP_INDUSTRIES_SECTION_SUBLINE"
      linkUri={isLoggedIn ? undefined : ROUTES.industries}
    >
      <Styled.GridIndustries>
        {loading
          ? Array.from({ length: LIMIT }).map((_, index) => (
              <IndustryCard.Skeleton key={index} />
            ))
          : industriesCollection?.map((item) => (
              <IndustryCard key={item.id} item={item} />
            ))}
      </Styled.GridIndustries>
    </SectionContainer>
  );
};
